import { Component, OnInit, Input } from '@angular/core';
import { ProjectBuilding } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/';
import { forkJoin } from 'rxjs';
import { ProjectBuildingAddComponent } from '../project-building-add/project-building-add.component';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-project-building-list',
	templateUrl: './project-building-list.component.html',
	styleUrls: ['./project-building-list.component.scss']
})
export class ProjectBuildingListComponent implements OnInit {

	@Input()
	projectid: number;

	loading: boolean = false;
	rows: ProjectBuilding[];

	advancedSearch = new Search('projectbuilding');

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	constructor(
		private buildingService: CrudService<ProjectBuilding>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private modalService: NgbModal,
		private dialogService: DialogService
	) {
		this.advancedSearch.addSimpleFilter('projectid', this.projectid);

	}

	ngOnInit() {
		this.loadbuildings();
	}

	loadbuildings(): void {
		this.loading = true;
		this.rows = [];

		if (this.projectid) {
			this.advancedSearch.addSimpleFilter('projectid', this.projectid);
		}

		const datarequest = this.buildingService.searchEntities(ProjectBuilding, 'projectbuilding', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.buildingService.countEntities(ProjectBuilding, 'projectbuilding', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}

	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.loadbuildings();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.loadbuildings();
	}

	delete(building: ProjectBuilding): void {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-building-remove'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.buildingService.deleteEntity(ProjectBuilding, 'projectbuilding', building).subscribe(() => {
					this.translateService.get(['labels.building-removed', 'labels.buildings']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.building-removed'], messages['labels.buildings']);
						this.loadbuildings();
					});
				});
			}
		});

	}

	add(): void {

		const modal = this.modalService.open(ProjectBuildingAddComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.projectid = this.projectid;
		modal.componentInstance.loadAssociablebuildings();


		modal.result.then(() => {
			this.loadbuildings();
		}).catch(() => {
			this.loadbuildings();
		});

	}



}
